<template>
  <div class="home-main-page">
    <main-header :hasBanner="true" :type="'index'"></main-header>
    <section class="main-center">
      <div class="header-business">
        <a
          :href="item.url"
          class="business-item"
          v-for="(item, index) in business"
          :key="index"
          target="_blank"
        >
          <img :src="item.icon" alt="" />
          <span>{{ item.title }}</span>
        </a>
      </div>

      <div class="flex-box-bt">
        <div class="origin-box">
          <div class="home-item-title">
            <div>房源信息</div>
            <div class="more">更多 ></div>
          </div>
          <el-table :data="resourcesTable" style="width: 100%">
            <el-table-column prop="address" label="房屋坐落" width="250">
              <template slot-scope="scope">
                <div class="one-line-sl">{{ scope.row.address }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="housetypename" label="户型">
            </el-table-column>
            <el-table-column prop="architarea" label="面积"> </el-table-column>
            <el-table-column prop="startDate" label="申请日期">
            </el-table-column>
            <el-table-column
              align="centet"
              header-align="center"
              label="详细"
              width="80"
            >
              <template slot-scope="scope">
                <img
                  @click="goDetailPage(scope.row, '/resources/detail')"
                  style="width: 20px; cursor: pointer"
                  src="@/assets/img/search.png"
                  alt=""
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="tips-box">
          <div class="home-item-title">
            <div>通知公告</div>
            <div class="more">更多 ></div>
          </div>
          <div class="tab-tips-item" v-for="(item, index) in sdyw" :key="index">
            <a target="_blank" :href="item.url">
              <div class="new-item-title">
                <div class="new-item-lin">•</div>
                <span>{{ item.title }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="flex-box-bt">
        <div class="origin-box">
          <div class="home-item-title">
            <div>房价走势</div>
          </div>
          <div class="chart-line"></div>
        </div>

        <div class="tips-box">
          <div class="home-item-title">
            <div>房源查询</div>
          </div>
          <el-input placeholder="请输入房源编号"></el-input>
          <el-input
            style="margin-top: 24px"
            placeholder="请输入查询验证码"
          ></el-input>
          <el-button style="margin-top: 24px" type="primary">查询</el-button>
        </div>
      </div>

      <div class="flex-box-bt">
        <div style="width: 100%">
          <div class="home-item-title">
            <div>存量房挂牌交易量</div>
          </div>

          <div class="statistics">
            <div class="statistics-item">
              <div class="statistics-img-box">
                <div class="img-box"></div>
              </div>
              <div class="statistics-right">
                <div class="statistics-title">本月挂牌量</div>
                <div class="statistics-num">11</div>
              </div>
            </div>

            <div class="statistics-item">
              <div class="statistics-img-box">
                <div class="img-box"></div>
              </div>
              <div class="statistics-right">
                <div class="statistics-title">上月挂牌量</div>
                <div class="statistics-num">22</div>
              </div>
            </div>

            <div class="statistics-item">
              <div class="statistics-img-box">
                <div class="img-box"></div>
              </div>
              <div class="statistics-right">
                <div class="statistics-title">总挂牌量</div>
                <div class="statistics-num">33</div>
              </div>
            </div>

            <div class="statistics-item">
              <div class="statistics-img-box">
                <div class="img-box"></div>
              </div>
              <div class="statistics-right">
                <div class="statistics-title">本月交易量</div>
                <div class="statistics-num">33</div>
              </div>
            </div>

            <div class="statistics-item">
              <div class="statistics-img-box">
                <div class="img-box"></div>
              </div>
              <div class="statistics-right">
                <div class="statistics-title">上月交易量</div>
                <div class="statistics-num">33</div>
              </div>
            </div>

            <div class="statistics-item">
              <div class="statistics-img-box">
                <div class="img-box"></div>
              </div>
              <div class="statistics-right">
                <div class="statistics-title">总交易量</div>
                <div class="statistics-num">33</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="position: relative">
        <div class="bottom-more-btn">更多 ></div>

        <el-tabs v-model="activeName" class="tab-bottom-box">
          <el-tab-pane label="机构挂牌量排名" name="first">
            <el-table :data="signTable" style="width: 100%">
              <el-table-column prop="rank" label="排名" width="180">
              </el-table-column>
              <el-table-column prop="name" label="机构名称" >
              </el-table-column>
              <el-table-column prop="listingNum" label="挂牌量" width="280"> </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="机构签约量排名" name="second">
            <el-table :data="signTable" style="width: 100%">
              <el-table-column prop="rank" label="排名" width="180">
              </el-table-column>
              <el-table-column prop="name" label="机构名称" >
              </el-table-column>
              <el-table-column prop="listingNum" label="挂牌量" width="280"> </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="信用积分排名" name="third">
            <el-table :data="signTable" style="width: 100%">
              <el-table-column prop="rank" label="排名" width="180">
              </el-table-column>
              <el-table-column prop="name" label="机构名称">
              </el-table-column>
              <el-table-column prop="listingNum" label="挂牌量" width="280"> </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>


		

<script>
import * as echarts from "echarts";
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import { newList } from "@/assets/api/index";
import { resourcesList } from "@/assets/api/resources";
import { creditList } from "@/assets/api/credit";



export default {
  name: "App",
  components: {
    mainHeader,
    mainFooter,
  },

  data() {
    return {
      business: [
        {
          url: "#/resources/release",
          title: "我要卖房",
          icon: require("@/assets/img/mai.png"),
        },
        {
          url: "#/nstock",
          title: "我要买房",
          icon: require("@/assets/img/mf.png"),
        },
        {
          url: "#/nrent",
          title: "我要租房",
          icon: require("@/assets/img/zf.png"),
        },
        {
          url: "#/resources/release",
          title: "我要出租",
          icon: require("@/assets/img/chuzu.png"),
        },
      ],
      lbList: [],
      activeName: "first",
      gzdt: [],
      sdyw: [],
      lcyw: [],

      tableData: [
        {
          date: "1",
          name: "机构",
          address: "22",
        },
        {
          date: "2",
          name: "机构",
          address: "22",
        },
        {
          date: "3",
          name: "机构",
          address: "22",
        },
        {
          date: "4",
          name: "机构",
          address: "22",
        },
      ],
      resourcesTable: [],
      signTable: []
    };
  },
  computed: {},
  mounted() {
    this.getNew(4);
    this.getNew(1);
    this.getNew(2);
    this.getNew(3);
    this.initChart();

    this.getResourcesList();
    this.getSignList()
  },
  methods: {
    goDetailPage(item, url) {
      const jumpUrl = this.$router.resolve({
        path: url,
        query: { id: item.id },
      });
      window.open(jumpUrl.href, "_blank");
    },
    async getSignList() {
      const res = await creditList({
        pageNum: 1,
        pageSize: 5,
      });
      if (res && res.data && res.data.code == 200) {
          this.signTable = res.data.rows || [];
      }
    },
    async getResourcesList() {
      const res = await resourcesList({
        pageNum: 1,
        pageSize: 4,
      });
      if (res && res.data && res.data.code == 200) {
        this.resourcesTable = res.data.rows || [];
      }
    },
    jump(url) {
      const jumpUrl = this.$router.resolve({ path: url });
      window.open(jumpUrl.href, "_blank");
    },
    async getNew(type) {
      const res = await newList({ type: type });
      if (res && res.data && res.data.code == 200) {
        const list = res.data.rows || [];
        if (type === 1) {
          this.gzdt = list;
        }

        if (type === 2) {
          this.sdyw = list;
        }
        if (type === 3) {
          this.lcyw = list;
        }
        if (type === 4) {
          this.lbList = list;
        }
      }
    },
    initChart() {
      let chartDom = document.querySelector(".chart-line");
      let myChart = echarts.init(chartDom);
      let option = (option = {
        color: ["#c3241c"],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [1, 2, 3, 4, 5],
          axisTick: {
            show: false,
          },
        },
        grid: {
          left: "0%",
          top:"10%",
          bottom:"10%",
          right: "2%",
          containLabel: true,
        },

        yAxis: {
          type: "value",
        },
        tooltip: {
          show: true,
          trigger: "axis",
        },
        series: [
          {
            data: [40, 20, 35, 60, 55, 10],
            type: "line",
            name: "支出",
            legendHoverLink: true,
            labelLine: {
              show: true,
              showAbove: true,
            },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#c3241c", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#FFFFFF", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
          },
        ],
      });
      option && myChart.setOption(option);
    },
  },
};
</script>

<style lang="less">
.home-main-page {
  background: #fff;
  .index-page-top {
    width: 100%;
    padding: 10px 0 0 0;
    display: flex;
    justify-content: space-between;
  }

  .header-business {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1140px;
    margin: 0 auto;
    padding-top: 12px;
    padding-bottom: 12px;
    .business-item {
      height: 60px;
      width: 260px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      box-sizing: border-box;
      border-radius: 5px;
      background-color: #fff;
      box-shadow: 0px 0px 20px 0px rgba(206, 206, 206, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 60px;
      transition: all 0.4s;
      img {
        width: 34px;
        height: auto;
        margin-right: 14px;
      }
      &:hover {
        transform: translateY(-4px);
      }
    }
  }
  .car-box {
    width: 466px;
    height: 300px;
    flex-shrink: 0;
    .car-img {
      width: 466px;
      height: 300px;
      object-fit: cover;
      background: #eee;
    }
  }
  .bottom-more-btn {
    position: absolute;
    right: 0;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    color: #c3241c;
    z-index: 1;
    top: 2px;
  }
  .tab-bottom-box {
    margin: 42px 0;
    position: relative;

    .el-tabs__item {
      line-height: 1;
      height: 34px;
      font-size: 18px;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__item.is-active {
      color: #b1191a;
      &:hover {
        color: #b1191a;
      }
    }
    .el-tabs__item:hover {
      color: #b1191a;
    }
    .el-tabs__active-bar {
      background-color: #b1191a;
    }
  }
  .nav-list {
    display: flex;
    flex-wrap: wrap;
    padding: 30px 0;
    box-sizing: border-box;
    .nav-item {
      width: 262px;
      height: 160px;
      border-radius: 3px;
      display: flex;
      margin-right: 30.5px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 18px;
      flex-direction: column;
      cursor: pointer;
      img {
        height: 50px;
        width: auto;
        margin-bottom: 20px;
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  .flex-box-bt {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  .origin-box {
    width: 728px;
  }

  .chart-line {
    width: 728px;
    height: 180px;
  }

  .tips-box {
    width: 358px;
    button {
      width: 100%;
      background: #b1191a;
      border: none;
    }
  }
  .home-item-title {
    position: relative;
    padding-left: 12px;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: 500;
    color: #c3241c;
    height: 24px;
    line-height: 24px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 24px 0;
    & > div {
      height: 24px;
    }
    .more {
      font-size: 14px;
      cursor: pointer;
    }
  }
  .home-item-title:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 24px;
    background-color: #c3241c;
  }

  .tab-tips-item {
    width: 100%;
    height: 39px;
    line-height: 39px;
    a {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #000;
      border-top: 1px solid #eee;

      .new-item-title {
        display: flex;
        align-items: center;
        .new-item-lin {
          padding-right: 5px;
          text-decoration: none;
          flex-shrink: 0;
        }
        span {
          width: 400px;

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .statistics {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    .statistics-item {
      flex: 1;
      margin-right: 18px;
      height: 100px;
      padding: 12px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid #eee;
      &:last-child {
        margin-right: 0;
      }
      .statistics-img-box {
        width: 62px;
        height: 62px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.4s all;
        .img-box {
          width: 38px;
          height: 38px;
          background: url("../assets/img/ii-y.png") no-repeat 0 0;
          background-size: 100%;
        }
      }

      &:hover {
        .statistics-img-box {
          background: #3085ac;
          .img-box {
            background: url("../assets/img/ii-yb.png") no-repeat 0 0;
            background-size: 100%;
          }
        }
      }

      &:nth-of-type(2) {
        .img-box {
          background: url("../assets/img/ii-s.png") no-repeat 0 0;
          background-size: 100%;
        }
        &:hover {
          .statistics-img-box {
            background: #3eb974;
            .img-box {
              background: url("../assets/img/ii-sb.png") no-repeat 0 0;
              background-size: 100%;
            }
          }
        }
      }
      &:nth-of-type(3) {
        .img-box {
          background: url("../assets/img/ii-t.png") no-repeat 0 0;
          background-size: 100%;
        }
        &:hover {
          .statistics-img-box {
            background: #feb041;
            .img-box {
              background: url("../assets/img/ii-tb.png") no-repeat 0 0;
              background-size: 100%;
            }
          }
        }
      }
      &:nth-of-type(4) {
        .img-box {
          background: url("../assets/img/ii-y.png") no-repeat 0 0;
          background-size: 100%;
        }
        &:hover {
          .statistics-img-box {
            background: #3085ac;
            .img-box {
              background: url("../assets/img/ii-yb.png") no-repeat 0 0;
              background-size: 100%;
            }
          }
        }
      }
      &:nth-of-type(5) {
        .img-box {
          background: url("../assets/img/ii-s.png") no-repeat 0 0;
          background-size: 100%;
        }
        &:hover {
          .statistics-img-box {
            background: #3eb974;
            .img-box {
              background: url("../assets/img/ii-sb.png") no-repeat 0 0;
              background-size: 100%;
            }
          }
        }
      }
      &:nth-of-type(6) {
        .img-box {
          background: url("../assets/img/ii-t.png") no-repeat 0 0;
          background-size: 100%;
        }
        &:hover {
          .statistics-img-box {
            background: #feb041;
            .img-box {
              background: url("../assets/img/ii-tb.png") no-repeat 0 0;
              background-size: 100%;
            }
          }
        }
      }

      .statistics-title {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 8px;
      }
      .statistics-num {
        font-size: 18px;
        color: #666;
        font-weight: bold;
        text-align: right;
      }
    }
  }
  .one-line-sl {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 240px;
  }
}
</style>